



































































import Vue from 'vue'
import Payment from '@/components/Services/Remittances/Payment.vue'
import Confirmation from '@/components/Services/Remittances/Confirmation.vue'
import ConfirmButtons from '@/components/ConfirmButtons.vue'
import { Step } from '@/utils/interfaces'
import ClientOriginForm from '@/components/Services/Remittances/ClientOriginForm.vue'
import ClientDestinyForm from '@/components/Services/Remittances/ClientDestinyForm.vue'
import FlatCard from '~/components/FlatCard.vue'

export default Vue.extend({
  beforeRouteLeave(to, from, next) {
    this.$store.commit('remittance/resetRemittance')
    this.loading = false
    next()
  },
  components: {
    ClientOriginForm,
    ClientDestinyForm,
    Payment,
    Confirmation,
    appConfirmButtons: ConfirmButtons,
    FlatCard,
  },
  props: {
    mlc: Boolean,
    mlx: Boolean,
    ust: Boolean,
  },
  data() {
    return {
      stepperModel: 1,
      steps: [
        'sender-information',
        'receiver-information',
        'payment',
        'confirmation',
      ],
      components: [
        'ClientOriginForm',
        'ClientDestinyForm',
        'Payment',
        'Confirmation',
      ],
      data: {},
      loading: false,
    }
  },
  methods: {
    onNextStep(payload: object | boolean) {
      this.updateAndContinue(payload)
    },
    updateAndContinue(data: boolean | object) {
      if (data) {
        switch (this.stepperModel) {
          case 1:
            this.data = {
              ...this.data,
              ...(data as object),
            }
            break
          case 2:
            this.data = { ...this.data, client_destiny: data }
            break
          case 3:
            this.data = { ...this.data, ...(data as object) }
            break
          default:
            break
        }
        this.onSuccess()
      }
    },
    async onNext() {
      try {
        this.loading = true
        const step = (this.$refs.step as Step[])[this.stepperModel - 1]
        const data = await step.onNext()
        this.updateAndContinue(data)
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    onPrev() {
      if (this.stepperModel > 1) {
        this.stepperModel--
      }
    },
    onSuccess() {
      if (this.stepperModel < this.steps.length) {
        this.stepperModel++
      }
    },
  },
  mounted() {
    // window.onbeforeunload = () => 'Confirm to leave the page?'
  },
  beforeDestroy() {
    window.onbeforeunload = null
  },
})
